import { hexToHSL } from './hexToHSL';

export const bootTheme = (theme) => {
  theme.primary && document.documentElement.style.setProperty('--primary', hexToHSL(theme.primary));
  theme.secondary && document.documentElement.style.setProperty('--secondary', hexToHSL(theme.secondary));
  theme.nav.link.default && document.documentElement.style.setProperty('--nav-link-default', hexToHSL(theme.nav.link.default));
  theme.nav.link.hover && document.documentElement.style.setProperty('--nav-link-hover', hexToHSL(theme.nav.link.hover));
}
